//var product_handle = "twisted-cobb-salad";
var enable_dates = []
//var gift_variant_id = document.getElementById("cart-v1-js").dataset.giftVariantId;
function formatDate(d) {
  var day = d.getDate()
  var month = (d.getMonth() + 1)
  if (day<10){
    day = "0"+day;
  }
  else{
    day = String(day)
  }
  if (month<10){
    month = "0"+month
  }
  else{
    month = String(month)
  }
  return d.getFullYear() + "-" + month + "-" + day
}

function parseDeliveryDateInput(rawValue) {
  var raw = (rawValue || "").trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    var parts = raw.split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2]);
  }

  return new Date(raw);
}
//on ready function for auto filling the catering into cart page selection
$(document).ready(function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var view = urlParams.get('view')
  if(view == "catering"){
    document.getElementById("deliveryGeoSearchFieldnew").value = "catering";
  }
  else if(view == "eastcatering"){
    document.getElementById("deliveryGeoSearchFieldnew").value = "oncatering";
  }
  else if(view == "group-order"){
    document.getElementById("deliveryGeoSearchFieldnew").placeholder = "Enter your group order name or code";
    document.getElementById("new_progress").style = "display:none";
    document.getElementById("delivery_type_text").innerHTML = 'Enter your company name for group ordering';
    document.getElementById("delivery_type_checkbox").style = "display:none";
    document.getElementById("dynamic-checkout-cart").style = "display:none!important";
  }
  else if(view == "offer"){
    console.log("In offer view")
    document.getElementById('cart_onetime_radio_section').style = "display:none;"
    document.getElementById("sub_header").innerHTML = 'New Customer Offer';
    document.getElementById("sub_text").innerHTML = 'Join our easy-to-manage subscription and unlock 4 free meals across your first 4 orders. Enjoy 5% off every order. Easily skip, pause, or cancel anytime. Modify your order each week with no hassle.';
  }

  //discount code read to change wording on the cart page
  var discountCode = getCookie("discount_code");
  /*
  if (discountCode === "WELCOME25" || discountCode === "SAMMY25") {
  */

    var w30 = window.WELCOME30_OFFER;
    if (w30 && discountCode && String(discountCode).toUpperCase() === String(w30.code).toUpperCase()) {
    // WELCOME30 earned-credit ladder — numbers/copy from Settings → WELCOME30 Cash Back Offer
    var cb = w30.cashback;
    var htmlToAppend = `
    <div>
      <ul>
        <li><strong>1st Order:</strong> ${w30.firstPct}% OFF + earn ${cb[0]}% back</li>
        <li><strong>2nd Order:</strong> ${cb[0]}% back applied + 5% OFF</li>
        <li><strong>3rd Order:</strong> ${cb[1]}% back applied + 5% OFF</li>
        <li><strong>4th Order:</strong> ${cb[2]}% back applied + 5% OFF</li>
        <li><strong>5th Order & Beyond:</strong> 5% OFF</li>
      </ul>
      <p style="font-size:12px;">${w30.copy.footnote || ''}</p>
      <br>
      <span><strong>Why Subscribe?</strong></span>
      <ul style="list-style-type:none;">
        <li>✔️ Flexible – Skip or cancel anytime.</li>
        <li>✔️ Customizable - Choose your meals each week.</li>
      </ul>
    </div>`;

    document.getElementById("sub_header").innerHTML = '✨ SUBSCRIBE & EARN CASH BACK ✨';
    document.getElementById("sub_text").innerHTML = htmlToAppend;
    document.getElementById("onetime_text").innerHTML = `Place a one time order with no automatic charges and no commitments to order again. <em>Please note: The new customer offer is only available for subscription orders</em>`;
  }
  else if (discountCode.endsWith("25")) {
    var htmlToAppend = `
    <div>
      <ul>
        <li><strong>1st Order:</strong> 30% OFF</li>
        <li><strong>2nd Order:</strong> 20% OFF</li>
        <li><strong>3rd Order:</strong> 15% OFF</li>
        <li><strong>4th Order:</strong> 10% OFF</li>
        <li><strong>5th Order & Beyond:</strong> 5% OFF</li>
      </ul>
      <br>
      <span><strong>Why Subscribe?</strong></span>
      <ul style="list-style-type:none;">
        <li>✔️ Flexible – Skip or cancel anytime.</li>
        <li>✔️ Customizable - Choose your meals each week.</li>
      </ul>
    </div>`;
    
    document.getElementById("sub_header").innerHTML = '✨ SUBSCRIBE & SAVE ON EVERY ORDER ✨';
    document.getElementById("sub_text").innerHTML = htmlToAppend;
    document.getElementById("onetime_text").innerHTML = `Place a one time order with no automatic charges and no commitments to order again. <em>Please note: The new customer offer is only available for subscription orders</em>`;
  }
  else if(discountCode == "GET50" || discountCode.toUpperCase().indexOf("50OFF") !== -1){
    var htmlToAppend = `
    <div>
      <ul>
        <li><strong>1st Order:</strong> 50% OFF</li>
        <li><strong>2nd Order & Beyond:</strong> 5% OFF</li>
      </ul>
      <br>
      <span><strong>Why Subscribe?</strong></span>
      <ul style="list-style-type:none;">
        <li>✔️ Flexible – Skip or cancel anytime.</li>
        <li>✔️ Customizable - Choose your meals each week.</li>
      </ul>
    </div>`;
    
    document.getElementById("sub_header").innerHTML = '✨ SUBSCRIBE & SAVE ON EVERY ORDER ✨';
    document.getElementById("sub_text").innerHTML = htmlToAppend;
    document.getElementById("onetime_text").innerHTML = `Place a one time order with no automatic charges and no commitments to order again. <em>Please note: The new customer offer is only available for subscription orders</em>`;
  }
  else if(discountCode.startsWith("FRIEND-")){
    var htmlToAppend = `
    <div>
      <p><strong>🎉 YOUR REFERRAL REWARD: $20 OFF 🎉</strong></p>
      <ul>
        <li><strong>1st Order:</strong> $20 OFF</li>
        <li><strong>2nd Order & Beyond:</strong> 5% OFF</li>
      </ul>
      <p>Your referral discount will be applied automatically at checkout.</p>
      <br>
      <span><strong>Why Subscribe?</strong></span>
      <ul style="list-style-type:none;">
        <li>✔️ Flexible – Skip or cancel anytime.</li>
        <li>✔️ Customizable - Choose your meals each week.</li>
      </ul>
    </div>`;

    document.getElementById("sub_header").innerHTML = '✨ SUBSCRIBE & SAVE ON EVERY ORDER ✨';
    document.getElementById("sub_text").innerHTML = htmlToAppend;
    document.getElementById("onetime_text").innerHTML = `Place a one time order with no automatic charges and no commitments to order again. <em>Please note: The referral offer is only available for subscription orders.</em>`;
  }

  console.log(discountCode);

  //console.log(urlParams)
});

//on ready function for catring and changing the cart page layout
/*
$(document).ready(function () {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var view = urlParams.get('view')
  if(view == "group-order"){
    document.getElementById("deliveryGeoSearchFieldnew").value = "grouporder";
    document.getElementById("new_progress").style = "display:none";
    document.getElementById("delivery_type_text").innerHTML = 'Enter your company name for group ordering';
    document.getElementById("delivery_type_checkbox").style = "display:none";
    document.getElementById("dynamic-checkout-cart").style = "display:none!important";
  }

  console.log(urlParams)
});
*/

$(document).ready(function () {
  $('#inline_cal').datepicker(
    {
      format: 'yyyy-mm-dd',
      beforeShowDay: function (date) {
        if (enable_dates.length>0 && enable_dates.indexOf(formatDate(date)) < 0)
            return {
              enabled: false
            }
          else
            return {
              enabled: true
            }
      }
    }
  );

  $('#inline_cal').datepicker().on('changeDate',(e)=>{
    //console.log("eeeee",e)
    //console.log(e.date.toISOString().split('T')[0])
    //var isoDate = e.date.toISOString().split('T')[0];
    var y = e.date.getFullYear();
    var m = String(e.date.getMonth() + 1).padStart(2, "0");
    var d = String(e.date.getDate()).padStart(2, "0");
    var isoDate = `${y}-${m}-${d}`;
    // ✅ Store ISO date in the field used later for parsing
    document.getElementById("input_delivery_date").value = isoDate;
    //document.getElementById("input_delivery_date").value = e.date.toLocaleString('en-US', {
      //weekday: 'long',
      //year: 'numeric',
      //month: 'long',
      //day: 'numeric'
    //});

    const select = document.getElementById("deleiveryTime");

    console.log(select);

      const options = {
        method: 'GET',
        headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' }
      };

    fetch(`https://api.zapiet.com/v1.0/delivery/locations/${location_id}/calendar/${isoDate}?shop=inspiredgo.myshopify.com`, options)
    .then(response => response.json())
    .then(async res => {
      console.log(res)
      if(select.options.length > 0){
        while (select.options.length > 0) {
          select.remove(0);
        }
      }
      //else{
      //check for catering location and add window selections as needed
      if(location_id == 252149 || location_id == 285777){
        for(var i =0;i<res.length;i++){
          let fromTimeConvert = (res[i].available_from.split(':')[0] % 12);
          let untilTimeConvert = (res[i].available_until.split(':')[0] % 12);
          if(fromTimeConvert == 0){
            fromTimeConvert = 12;
          }
          if(untilTimeConvert == 0){
            untilTimeConvert = 12
          }
          //will have to add in a if function to check for existing options and remove options if they exist before adding new ones
          let delieveryWindow = `${fromTimeConvert}:${res[i].available_from.split(':')[1]} - ${untilTimeConvert}:${res[i].available_until.split(':')[1]}`;

          let newOption = new Option(`${delieveryWindow}`,`${delieveryWindow}`);
          select.add(newOption,undefined);

        }
      }
      //change the delievery window for all locations other then catering
      else{
        //breakdown the times for each city and day
        if(location_id == 137796 && res[0].day_of_week == "friday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>1pm and 6pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 137796 && res[0].day_of_week == "sunday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 137796 && res[0].day_of_week == "monday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>11am and 6pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //Toronto
        else if(location_id == 242677 && res[0].day_of_week == "sunday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 242677 && res[0].day_of_week == "monday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //Ottawa
        else if(location_id == 285794 && res[0].day_of_week == "sunday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 2pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 285794 && res[0].day_of_week == "monday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 2pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //London ON
        else if(location_id == 289774 && res[0].day_of_week == "sunday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 289774 && res[0].day_of_week == "monday") {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }  
        //Vancouver
        else if(location_id == 137798 || location_id == 270994) {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //LA
        else if(location_id == 278438 && res[0].day_of_week == "monday" ) {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else if(location_id == 278438 && res[0].day_of_week == "sunday" || location_id == 288949 && res[0].day_of_week == "sunday" ) {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //USA-West
        //Vegas
        else if(location_id == 273216){
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 3pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //San Francisco
        else if(location_id == 279269){
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //Denver
        else if(location_id == 299051){
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //Salt Lake City
        else if(location_id == 276649){
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //Phoenix
        else if(location_id == 277960){
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //San Deago
        else if(location_id == 288292) {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        //USA East
        //NY
        else if(location_id == 301948) {
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>8am and 8pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
        else{
          document.getElementById("delWindowText").innerHTML = `Delivery window between <b>10am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
        }
      }
      //}
    })

    if(document.getElementById('cart_subscribe_radio').checked){
      document.getElementById("change_button_click_id").disabled = false;
    var date = e.date;
    var dayweek = date.toLocaleString('default', { weekday: 'long' });
      var month = date.toLocaleString('default', { month: 'long' });
      var day = date.getDate();
      var year = date.getFullYear();
      document.getElementById("loader_new_cart").style = `display:none!important`
      var append_text = ``;
      try {
      if (dayweek.toLowerCase() !== document.getElementById("day_selection_subscription").value.toLowerCase()) {
      append_text = `<span class="info_icon hover_mouse" style="font-weight:200; text-transform: lowercase;" onclick="show_info_new()">&#9432;</span>`
      }
      } catch (error) { }
      if(location_id == 137796 && dayweek == "Monday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>11am and 6pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id == 137796 && dayweek == "Sunday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //toronto
      else if(location_id == 242677 && dayweek == "Monday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 2pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id == 242677 && dayweek == "Sunday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //Ottaw  
      else if(location_id == 285794 && dayweek == "Monday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 2pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id == 285794 && dayweek == "Sunday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 2pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //London On
      else if(location_id == 289774 && dayweek == "Monday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id == 289774  && dayweek == "Sunday") {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //Vancouver  
      else if(location_id == 137798 || location_id == 270994) {
         document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //LA
      else if(location_id == 278438 && dayweek == "Monday") {
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id == 278438 && dayweek == "Sunday" || location_id == 288949 && dayweek == "Sunday" ) {
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //USA-West
      //Vegas
      else if(location_id == 273216){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 3pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //San Francisco
      else if(location_id == 279269){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //Denver
      else if(location_id == 299051){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //Salt Lake City
      else if(location_id == 276649){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //Phoenix
      else if(location_id == 277960){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>9am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //San Deago
      else if(location_id == 288292) {
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>7am and 5pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      else if(location_id != 137796 || location_id != 242677 || location_id != 137798 || location_id != 270994 || location_id != 285794 || location_id != 289774 ){
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>10am and 4pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      //USA East
      //NY
      else if(location_id == 301948) {
        document.getElementById("subscription_date_text").innerHTML = `<b>${dayweek}, ${month} ${day}, ${year} ${append_text}</b> <br> between <b>8am and 8pm</b> <br><span class='info_icon hover_mouse' style='color: red;text-decoration: underline;background-color: #eee;' onclick='show_info()'>More Information<span>`
      }
      if(location_id == 270213){
        //document.getElementById("greater_toronto_sub_selection").style = "display:block";
        document.getElementById("delivery_day_2").style = "display:block";
      }
      else{
        document.getElementById("delivery_day_2").style = "display:block";
      }
      document.getElementById("order_type").style = "display:none";
      document.getElementById("order_type_heading").style = "display:none";
      document.getElementById("postal_code_button_2").innerHTML = 'NEXT STEP';
      document.getElementById("postal_code_button_2").disabled = false;
      document.getElementById("order_type_completion").innerHTML = `PLACING A SUBSCRIPTION ORDER`;
      document.getElementById("order_type_completion").style = `display:block`;
    }

  });

})


var location_id = null;
var gift_cards = [ 31478736748586, 31478736781354, 31478736814122, 31478736846890 ]

//function to return, per region, the titles of cart products NOT available in that region
  async function getProductsWithTorontoTags(){
    let cartItemsHandle = [];
    const productMap = {
      "toronto": [],
      "calgary": [],
      "quebec": [],
      "usa-west": [],
      "usa-east": []
    }

    await fetch("/cart.js")
        .then(response => response.json())
        .then((response) => {

          let cartItemsArray = response.items;

          //goes through the products in cart and checks if they have a toronto tag
          for(let i=0; i<cartItemsArray.length; i++){
            cartItemsHandle.push(cartItemsArray[i].handle);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })

      for(let i=0; i<cartItemsHandle.length; i++){
         await fetch(`/products/${cartItemsHandle[i]}.js`)
              .then(response => response.json())
              .then((response) => {
                // Same rules as the cart sidebar: snippets/region-availability.liquid (window.IGRegion)
                Object.keys(productMap).forEach((region) => {
                  if (!window.IGRegion.isAvailableIn(response.tags, region)) {
                    productMap[region].push(response.title)
                  }
                })
              })
              .catch((error) => {
                console.error('Error:', error);
            })
      }
    return productMap;
  }

//Helper function for displaying the correct information after a succesful check from the postal button
async function postalButtonHelper(res){

  location_id = res.id;
  await addBundleProps()
  document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
  document.getElementById("postal_code_button").disabled = false;
  document.getElementById("delivery_type_checkbox").style = "display:none";
  // document.getElementById("deliveryGeoSearchField").style = "display:none";
  document.getElementById("deliveryGeoSearchFieldnew").style = "display:none";

  document.getElementById("delivery_type_text").style = "display:none";
  document.getElementById("postal_code_button").style = "display:none";
  var z = document.getElementById("postal_code_complete");
  var y = document.getElementById("delivery_day");
  var order_type = document.getElementById("order_type");
  order_type.style = "display:block";
  document.getElementById("cart_subscribe_radio_section").style = "display:block";
  y.style = "display:none;"
  z.innerHTML = `<p class='postal_code_completion'>Shipping to ${document.querySelector("#deliveryGeoSearchFieldnew").value}</p>
        <div class="d-flex justify-content-center">
        <button type="button" class="change_button_class" style="background-color: transparent;" id="change_button_click_id" onclick="change_button_click()"
          >change</button></div>`

  document.getElementById("postal_code_button").disabled = false;
}

function postal_code_email_button_on_click(){

  var failedPostal = document.getElementById("deliveryGeoSearchFieldnew").value;
  var customerEmail = document.getElementById("enterEmail").value;
  console.log(failedPostal);

  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    "failedPostal": failedPostal,
    "customerEmail": customerEmail
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    mode: "no-cors",
    redirect: 'follow'
  };

  fetch("https://script.google.com/macros/s/AKfycbzzR76RX9p_XEnHd_-iZsIfhkyhGaZrEjXGd11PsXOsKOoUzWy89BPVATMxcD6-I6Q9/exec", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));

  document.getElementById("submitEmailButton").innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';
  document.getElementById("error_cart_zapiet").innerHTML = `<p role="alert" id="submitMessage">Your email has been submitted</p>`
  document.getElementById("failedPostalEmail").style = "display:none";
  document.getElementById("submitEmailButton").style = "display:none";
}

function cartCheckToSheet(menuCatch, products ,postalCode){
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    "menu": menuCatch,
    "products":products,
    "postalAssociated": postalCode
  });

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    mode: "no-cors",
    redirect: 'follow'
  };

  fetch("https://script.google.com/macros/s/AKfycbzYzDdBSJwN1kbNHdhO6jyN31juEUiyh17keTIevrD44gnJv9RnJhWbChykzQjlFH8mRg/exec", requestOptions)
    .then(response => response.text())
    .then(result => console.log(result))
    .catch(error => console.log('error', error));
}

async function postal_code_button_on_click() {
  console.log("in postal button function");
  document.getElementById("postal_code_button").disabled = true;
  document.getElementById("error_cart_zapiet").innerHTML = "";
  document.getElementById("postal_code_button").innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';

  if (!(document.getElementById("deliveryGeoSearchFieldnew").value || "").trim()) {
    document.getElementById("error_cart_zapiet").innerHTML = `<p role="alert" class="error">
	Please enter a valid postal code to select your preferred delivery date
	</p>`;
    document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
    document.getElementById("postal_code_button").disabled = false;
    return;
  }

  var data = {
    geoSearchQuery: document.getElementById("deliveryGeoSearchFieldnew").value,
    shop: "inspiredgo.myshopify.com"
  }
  const data_a = new URLSearchParams();

  for (var key in data) {
    data_a.append(key, data[key]);
  }


  const options = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
    body: data_a
  };


              //https://api.zapiet.com/v1.0/delivery/locations
  await fetch('https://api.zapiet.com/v1.0/delivery/locations?shop=inspiredgo.myshopify.com', options)
    .then(response => response.json())
    .then(async res => {
      if (res.error) {
        // Fire GTM event for non-serviceable zip
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'non_serviceable_zip' });

        //document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">Sorry, delivery is not available in your area. If you believe you are receiving this message by mistake please send us a message. If you would like to request your area be added to our delivery routes, please message us with a request! We are looking to expand and want to know where we should go next. Please send a quick message through the blue chat icon below or to info@inspiredgo.ca</p>`
        document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" id="postalMessage"> Delivery is currently not available in your area; however, we are expanding quickly. Leave your email below and get notified when we cover your area!</p>`
        document.getElementById("second_message").innerHTML = ` <p role="alert" class="error"> If you believe you are receiving this message in error, please email info@inspiredgo.ca</p>`
        document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
        document.getElementById("postal_code_button").disabled = false;
        document.getElementById("failedPostalEmail").style = "display:block";
        document.getElementById("submitEmailButton").style = "display:flex"

            var failedPostal = document.getElementById("deliveryGeoSearchFieldnew").value;
            console.log(failedPostal);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
              "failedPostal": failedPostal
            });

            var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: raw,
              mode: "no-cors",
              redirect: 'follow'
            };

            fetch("https://script.google.com/macros/s/AKfycbzzR76RX9p_XEnHd_-iZsIfhkyhGaZrEjXGd11PsXOsKOoUzWy89BPVATMxcD6-I6Q9/exec", requestOptions)
              .then(response => response.text())
              .then(result => console.log(result))
              .catch(error => console.log('error', error));

      }
      else {
        //if - check for customers that are entering a toronto zip
        const productTags = getProductsWithTorontoTags();
        var postalCode = document.getElementById("deliveryGeoSearchFieldnew").value;
        //the below id will need to be changed on launch day
        //235451 - test
        //242677 - toronto
        //270213 - greater toronto area id
        //285777 - Ontario catering
        //285794 - Ottawa
        if(res.id == 242677 || res.id == 270213 || res.id == 285794 || res.id == 289774 || res.id == 319959){
          //alert("In Toronto test ID")
          let totalPrice = 0;
          let discountAmount = 0;
          await fetch("/cart.js")
          .then(response => response.json())
          .then((response) => {

            let cartItemsArray = response.items;
            totalPrice = response.total_price;
            discountAmount = response.total_discount

            //goes through the products in cart and checks if they have a toronto tag
            //for(let i=0; i<cartItemsArray.length; i++){
              //cartItemsHandle.push(cartItemsArray[i].handle);
            //}
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          if(totalPrice+discountAmount < 4000){
            console.log("total price less then 140")
            document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">It looks like your order is below the $40.00 minimum order amount, please added some items to your cart.</p>`
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
          }
          else{
          // 319959 is the Quebec location; the rest of this branch is Ontario
          const regionKey = res.id == 319959 ? 'quebec' : 'toronto';
          productTags.then((data) => {
            if(data[regionKey].length > 0){
              document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">You added some products that aren’t available in your region.
              We look forward to expanding and bringing these items to you! Please remove the following items:</p>`
              for(let i=0;i<data[regionKey].length;i++){
                document.getElementById("error_cart_zapiet").innerHTML += ` <p role="alert" class="error">- ${data[regionKey][i]}</p>`
                var imgElement = document.querySelector(`img[alt="${data[regionKey][i]}"]`)
                if (imgElement) imgElement.style = "border: 2px solid red;"
                var cartItem = document.getElementById(`CartItem-${data[regionKey][i]}`)
                if (cartItem) cartItem.style = "background-color: rgba(255, 0, 0, 0.2);"
              }
              //var imgElement = document.querySelector(`img[alt="${data[0][0]}"]`)
              //imgElement.style = "border: 2px solid red;"
              document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
              document.getElementById("postal_code_button").disabled = false;

              //the below function sends a too a google sheet of the menu, product and postal that the cart had cross over products in
              // cartCheckToSheet("Calgary products in Toronto", data['toronto'] ,postalCode)
            }
            else{
              buildDeliveryDaySelectFromZapietLocation(res);
              postalButtonHelper(res)
            }
          });
          }
        }
        // 273216 - usa west
        else if(res.id == 273216 || res.id == 279269 || res.id == 299051 || res.id == 276649 || res.id == 277960 || res.id == 288292 || res.id == 278438 || res.id == 301750){
          let totalPrice = 0;
          await fetch("/cart.js")
            .then(response => response.json())
            .then((response) => {
              totalPrice = response.total_price;
            })
            .catch((error) => {
              console.error('Error:', error);
            })

          if(totalPrice < 4000){
            console.log("total price less then 140")
            document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">It looks like your order is below the $40.00 minimum order amount, please added some items to your cart.</p>`
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
          } else {
            productTags.then((data) => {
              if(data['usa-west'].length > 0){
                document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">You added some products that aren’t available in your region. We look forward to expanding and bringing these items to you! Please remove the following items:</p>`
                for(let i=0;i<data['usa-west'].length;i++){
                  document.getElementById("error_cart_zapiet").innerHTML += ` <p role="alert" class="error">- ${data['usa-west'][i]}</p>`
                  var imgElement = document.querySelector(`img[alt="${data['usa-west'][i]}"]`)
                  if (imgElement) imgElement.style = "border: 2px solid red;"
                  var cartItem = document.getElementById(`CartItem-${data['usa-west'][i]}`)
                  if (cartItem) cartItem.style = "background-color: rgba(255, 0, 0, 0.2);"
                }
                document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
                document.getElementById("postal_code_button").disabled = false;
              } else {
                buildDeliveryDaySelectFromZapietLocation(res);
                postalButtonHelper(res)
              }
            });
          }
        }
        //usa east check
        else if(res.id == 301948 || res.id == 310459 || res.id == 310466){
          let totalPrice = 0;
          await fetch("/cart.js")
            .then(response => response.json())
            .then((response) => {
              totalPrice = response.total_price;
            })
            .catch((error) => {
              console.error('Error:', error);
            })

          if(totalPrice < 4000){
            console.log("total price less then 140")
            document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">It looks like your order is below the $40.00 minimum order amount, please added some items to your cart.</p>`
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
          } else {
            productTags.then((data) => {
              if(data['usa-east'].length > 0){
                document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">You added some products that aren’t available in your region. We look forward to expanding and bringing these items to you! Please remove the following items:</p>`
                for(let i=0;i<data['usa-east'].length;i++){
                  document.getElementById("error_cart_zapiet").innerHTML += ` <p role="alert" class="error">- ${data['usa-east'][i]}</p>`
                  var imgElement = document.querySelector(`img[alt="${data['usa-east'][i]}"]`)
                  if (imgElement) imgElement.style = "border: 2px solid red;"
                  var cartItem = document.getElementById(`CartItem-${data['usa-east'][i]}`)
                  if (cartItem) cartItem.style = "background-color: rgba(255, 0, 0, 0.2);"
                }
                document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
                document.getElementById("postal_code_button").disabled = false;
              } else {
                buildDeliveryDaySelectFromZapietLocation(res);
                postalButtonHelper(res)
              }
            });
          }
        }
        //section for the catering check for the cart and other
        else if(res.id == 252149 || res.id == 285777){
          console.log("in catering")
          let totalPrice = 0;
          await fetch("/cart.js")
          .then(response => response.json())
          .then((response) => {

            let cartItemsArray = response.items;
            totalPrice = response.total_price;

            //goes through the products in cart and checks if they have a toronto tag
            //for(let i=0; i<cartItemsArray.length; i++){
              //cartItemsHandle.push(cartItemsArray[i].handle);
            //}
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          if(totalPrice < 14250){
            console.log("total price less then 140")
            document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">It looks like your catering order is below the $150.00 minimum order amount, please added some items to your cart.</p>`
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
          }
          else{
          //display for having only the one time selected
            location_id = res.id;
            await addBundleProps()
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
            document.getElementById("delivery_type_checkbox").style = "display:none";
            // document.getElementById("deliveryGeoSearchField").style = "display:none";
            document.getElementById("deliveryGeoSearchFieldnew").style = "display:none";

            document.getElementById("delivery_type_text").style = "display:none";
            document.getElementById("postal_code_button").style = "display:none";
            var z = document.getElementById("postal_code_complete");
            var y = document.getElementById("delivery_day");
            var order_type = document.getElementById("order_type");
            order_type.style = "display:block";
            document.getElementById("cart_subscribe_radio_section").style = "display:none";
            document.getElementById('cart_subscribe_radio').checked = false;
            y.style = "display:none;"
            z.innerHTML = `<p class='postal_code_completion'>Shipping to ${document.querySelector("#deliveryGeoSearchFieldnew").value}</p>
                  <div class="d-flex justify-content-center">
                  <button type="button" class="change_button_class" style="background-color: transparent;" id="change_button_click_id" onclick="change_button_click()"
                    >change</button></div>`

            document.getElementById("postal_code_button").disabled = false;
          //end of display
          }//end of else for total price check
        } // end of catering else if statment
        //section for group ordering
        else if(res.id == 270576){
          console.log("in group order");
          //set the free shipping discount - will need to check for the 50% off discount
          var discountCode = getCookie("discount_code");
          console.log(discountCode);
          document.cookie = "discount_code=FREESHIP; secure"
          discountCode = getCookie("discount_code");
          console.log(discountCode);
          let totalPrice = 0;
          await fetch("/cart.js")
          .then(response => response.json())
          .then((response) => {

            let cartItemsArray = response.items;
            totalPrice = response.total_price;

            //goes through the products in cart and checks if they have a toronto tag
            //for(let i=0; i<cartItemsArray.length; i++){
              //cartItemsHandle.push(cartItemsArray[i].handle);
            //}
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          //display for having only the one time selected
            location_id = res.id;
            await addBundleProps()
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
            document.getElementById("delivery_type_checkbox").style = "display:none";
            // document.getElementById("deliveryGeoSearchField").style = "display:none";
            document.getElementById("deliveryGeoSearchFieldnew").style = "display:none";

            document.getElementById("delivery_type_text").style = "display:none";
            document.getElementById("postal_code_button").style = "display:none";
            var z = document.getElementById("postal_code_complete");
            var y = document.getElementById("delivery_day");
            var order_type = document.getElementById("order_type");
            order_type.style = "display:block";
            document.getElementById("cart_subscribe_radio_section").style = "display:none";
            document.getElementById('cart_subscribe_radio').checked = false;
            y.style = "display:none;"
            z.innerHTML = `<p class='postal_code_completion'>Shipping to ${document.querySelector("#deliveryGeoSearchFieldnew").value}</p>
                  <div class="d-flex justify-content-center">
                  <button type="button" class="change_button_class" style="background-color: transparent;" id="change_button_click_id" onclick="change_button_click()"
                    >change</button></div>`

            document.getElementById("postal_code_button").disabled = false;
          //end of display
        }//end of group order check
        else{
          //add in check for all other customers against having toronto products in their cart
          let totalPrice = 0;
          let discountAmount = 0;
          await fetch("/cart.js")
          .then(response => response.json())
          .then((response) => {

            let cartItemsArray = response.items;
            totalPrice = response.total_price;
            discountAmount = response.total_discount

            //goes through the products in cart and checks if they have a toronto tag
            //for(let i=0; i<cartItemsArray.length; i++){
              //cartItemsHandle.push(cartItemsArray[i].handle);
            //}
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          if(totalPrice+discountAmount < 4000){
            console.log("total price less then 140")
            document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">It looks like your order is below the $40.00 minimum order amount, please added some items to your cart.</p>`
            document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
            document.getElementById("postal_code_button").disabled = false;
          }
          else{
          if(res.id != 268448){
          productTags.then((data) => {
            if(data['calgary'].length > 0){
              //alert("This has toronto products");

              document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">You added some products that aren’t available in your region.
              We look forward to expanding and bringing these items to you! Please remove the following items:</p>`
              for(let i=0;i<data['calgary'].length;i++){
                document.getElementById("error_cart_zapiet").innerHTML += ` <p role="alert" class="error">- ${data['calgary'][i]}</p>`
                var imgElement = document.querySelector(`img[alt="${data['calgary'][i]}"]`)
                if (imgElement) imgElement.style = "border: 2px solid red;"
                var cartItem = document.getElementById(`CartItem-${data['calgary'][i]}`)
                if (cartItem) cartItem.style = "background-color: rgba(255, 0, 0, 0.2);"
                //border: 2px solid red;
              }
              //var imgElement = document.querySelector(`img[alt="${data[1][0]}"]`)
              //imgElement.style = "border: 2px solid red;"
              document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
              document.getElementById("postal_code_button").disabled = false;

              //the below function sends a too a google sheet of the menu, product and postal that the cart had cross over products in
              // cartCheckToSheet("Toronto products in Calgary", data['calgary'] ,postalCode)
            }
            else{
              buildDeliveryDaySelectFromZapietLocation(res);

              postalButtonHelper(res)
            }
          });
          }
           else{
             buildDeliveryDaySelectFromZapietLocation(res);

             postalButtonHelper(res)
           }
        }
        } //end of else
      }
    }).catch(error => {
      console.log(error)

      // Fire GTM event for non-serviceable zip (API error fallback)
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'non_serviceable_zip' });

      document.getElementById("error_cart_zapiet").innerHTML = ` <p role="alert" class="error">Sorry, delivery is not available in your area. If you believe you are receiving this message by mistake please send us a message. If you would like to request your area be added to our delivery routes, please message us with a request! We are looking to expand and want to know where we should go next. Please send a quick message through the blue chat icon below or to info@inspiredgo.ca</p>`
      document.getElementById("postal_code_button").innerHTML = 'NEXT STEP';
      document.getElementById("postal_code_button").disabled = false;

    })

}



function day_selection_subscription(displayloader) {
  if(displayloader)
  document.getElementById("loader_new_cart").style = "display:block";
  document.getElementById("subscription_date_text").innerHTML = "";

  var x = $("#day_selection_subscription").val()
  click_calender(x);



}



function change_button_click() {
  xcount = 1;
  document.getElementById("formStorePickupApp").innerHTML = `<div>
        <div class="inputWithButtonNew">
            <input type="text" placeholder="Enter your postal code ..." id="deliveryGeoSearchFieldnew" autocomplete="off" lazy="" class="snize-exclude-input">
        </div>
    </div>
    <div id="error_cart_zapiet"></div>
<div style="display:none">
    <div id="storePickupApp" ></div></div>`;
  document.getElementById("delivery_type_checkbox").style = "display:block";

  document.getElementById("order_type_heading").style = "display:block";
  document.getElementById("postal_code_button").style = "display:block";
  document.getElementById("postal_code_complete").innerHTML = "";
  document.getElementById("order_type_completion").innerHTML = "";
  document.getElementById("order_type_completion").style = "display:none";subscription_change
  document.getElementById("delivery_day_button_error").innerHTML = "";

  document.getElementById("delivery_day_button").style = "display:none !important";
  document.getElementById("delivery_day").style = "display:none !important";
  document.getElementById("delivery_day_2").style = "display:none !important";
  document.getElementById("greater_toronto_sub_selection").style = "display:none !important";

  // document.getElementById("delivery_day_2").innerHTML = "";
  document.getElementById("delivery_day_completion").style = "display:none";
  document.getElementById("delivery_day_text").style = "display:block";
  document.getElementById("end_checkout_div").style = "display:none !important";
  document.getElementById("delivery_window").style = "display:none";

  document.getElementById("delivery_window_text").style = "display:block"

  document.getElementById("order_type").style = "display:none";
  document.getElementById("timeSelectContainer").style = "display:none";
  // order_type.style = "display:none";


}

async function order_type_next_button() {
  var t = "ONE TIME";
  if (document.getElementById('cart_subscribe_radio').checked) {
    t = "SUBSCRIPTION";
  }
  var data = {
    geoSearchQuery: document.getElementById("deliveryGeoSearchFieldnew").value,
    shop: "inspiredgo.myshopify.com"
  }
  //             var form_data = new FormData();
  const data_a = new URLSearchParams();

  for (var key in data) {
    data_a.append(key, data[key]);
  }
  document.getElementById("postal_code_button_2").innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';
  document.getElementById("postal_code_button_2").disabled = true;
  document.getElementById("change_button_click_id").disabled = true;

  const options = {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;' },
    body: data_a
  };
  var options_select = `<option value="sunday">Sunday</option><option value="monday">Monday</option>`

  try {
    var res = await fetch(`https://api.zapiet.com/v1.0/delivery/locations/${location_id}/calendar?shop=inspiredgo.myshopify.com`, options)
    var re = await res.json();
    var daysOfWeekDisabled = [];
    var daysDisables = []
    var minDateEqualsDisabled = false;

    var minDay = re.minDate.split("-");
    minDay = minDay[2].split("0");
    minDay = minDay[0]

    enable_dates = [];
    if (re.disabled.length > 0 && re.disabled[0] === true) {
      re.disabled.slice(1).forEach(day => {
        if (Array.isArray(day)) {
          try {

            enable_dates.push(`${day[0]}-${day[1]<10?"0"+(day[1]+1): day[1]+1}-${day[2]<10?'0'+day[2]:day[2]}`)
          }
          catch (error) {
          }
        }
      })
      $('#inline_cal').datepicker('setStartDate', new Date(re.minDateTime.replace(/\s+/g, 'T').concat('.000+00:00')));

    if(enable_dates.length>0){

      $('#inline_cal').datepicker('setDate', new Date(enable_dates[0].concat('T00:00:00')));
    }
    } else {
      re.disabled.forEach(day => {
        //This if need to be expanded to day month year not just day
        if(day[2] == minDay){
          //minDateEqualsDisabled = true;
        }

        if (Array.isArray(day)) {
          try {
            daysDisables.push(`${day[0]}-${day[1] + 1}-${day[2]}`)
          }
          catch (error) {
          }
        } else {
          daysOfWeekDisabled.push(day - 1)
        }
      });
      $('#inline_cal').datepicker('setDaysOfWeekDisabled', daysOfWeekDisabled);
      $('#inline_cal').datepicker('setDatesDisabled', daysDisables);
      if(minDateEqualsDisabled == true){
        var newStartDate = new Date(re.minDateTime)
        console.log(newStartDate)
        var newStartDateString = newStartDate.toDateString();
        var completeNewDate = new Date(newStartDateString)
        completeNewDate.setDate(newStartDate.getDate()+6)
        console.log(completeNewDate)
        console.log(new Date(re.minDateTime.replace(/\s+/g, 'T').concat('.000+00:00')))
        $('#inline_cal').datepicker('setStartDate', new Date(completeNewDate));
        $('#inline_cal').datepicker('setDate', new Date(completeNewDate));
      }
      else{
        $('#inline_cal').datepicker('setStartDate', new Date(re.minDateTime.replace(/\s+/g, 'T').concat('.000+00:00')));
        $('#inline_cal').datepicker('setDate', new Date(re.minDateTime.replace(/\s+/g, 'T').concat('.000+00:00')));
      }
    }
    if (re.disabled.includes(2)) {
      options_select = '<option value="sunday">Sunday</option>'
    } else if (re.disabled.includes(1)) {
      options_select = '<option value="monday">Monday</option>'
      day_selected = "monday";
    }


  } catch (error) {
    console.log(error)
  }
  if (t == "SUBSCRIPTION") {
    var day_selected = "sunday";
    document.getElementById("subscription_button_div").style="";
    click_calender(day_selected);
  }
  else {
    // await getCart(false)
    await updateItemsWithSubscriptionOptions({type: 'onetime'})
    add_cart_attribute(true);
    // document.getElementById("deliveryGeoSearchField").style = "display:none";
    document.getElementById("deliveryGeoSearchFieldnew").style = "display:none";
    document.getElementById("change_button_click_id").disabled = false;

    document.getElementById("postal_code_button_2").innerHTML = 'NEXT STEP';
    document.getElementById("postal_code_button_2").disabled = false;
    document.getElementById("delivery_day_button").style = "display:block";
    // document.getElementById("deliveryDatePicker").style = "";

    var t = "ONE TIME";
    document.getElementById("order_type_completion").innerHTML = `PLACING A ${t} ORDER`;
    document.getElementById("order_type_completion").style = `display:block`;
    document.getElementById("order_type").style = "display:none";
    document.getElementById("order_type_heading").style = "display:none";
    document.getElementById("delivery_day").style = "display:block";

    //to display the time select input for catering
    //console.log(location_id);
    if(location_id == 252149 || location_id == 285777){
      document.getElementById("timeSelectContainer").style = "display:block";
    }
    else{
    //display delivery window text for all other locations then catering
    document.getElementById("timeSelectContainer").style = "display:block"
    document.getElementById("deleiveryTime").style = "display:none"
    }
  }


}


function click_calender(day_selected) {
  var x = document.getElementById("inline_cal");
  try {
    while (!document.getElementById("inline_cal").querySelector(".prev").classList.contains('disabled')) {
      document.getElementById("inline_cal").querySelector(".prev").click()
    }
  } catch (error) {

  }

  var y = x.querySelector(".datepicker-days")
  var date = ""
  var tds = y.querySelectorAll("td");
  for (var i = 0; i < tds.length; i++) {
    if (tds[i] && !tds[i].classList.contains('disabled')) {
      date = new Date(parseInt(tds[i].dataset.date));
      if (day_selected.toLowerCase() == "sunday") {
        if ((date.getUTCDay()==1 || date.getUTCDay()==0)) {
          tds[i].click()
          return tds[i]
        }
      } else {
        if (date.getUTCDay()==1) {
          tds[i].click()
          return tds[i]
        }
      }
    }
  }
}

async function add_cart_attribute(remove) {



  const formData = new FormData();
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  var view = urlParams.get('view')

  if (view) {
    view = `subscription_${view}`;
  } else {
    view = '';
  }
  if (remove) {
    view = ""
  }
  if (view) {
    fetch('/cart.js', {
      method: 'GET',

    }).then(res => res.json()).then(res => {
      for (var x in res.attributes) {
        if (x !== "Delivery-Date")
          formData.append(`attributes[${x}]`, '')
      }
      formData.append('attributes[cart_version]', view);


      fetch('/cart/update.js', {
        method: 'POST',

        body: formData
      })

    })

  }



}

//used for the next step button when a customer selects subscrition order
async function subscription_change() {
  document.getElementById("dynamic-checkout-cart").style="display:none!important"

  //235451 <- test location
  //252149 <- toronto location <- this is the new catering location id
  //242677 <- toronto real location
  //273216 <- vegas
  //276649 <- Salt Lakem city
  //277960 <- Phx
  //278438 <- LA
  //279269 <- SanFran
  //1364033578 - usa-west thursday | monday - weekly
  //1364066346 - usa-west thursday | monday - bi weekly
  //1364099114 - usa-west wed | sunday - weekly
  //1364131882 - usa-west wed | sunday - bi weekly
  /* if(location_id == 242677 || location_id == 270213){
    var data = {
      "monday": {
        "weekly": "873594922",
        "biweekly": "873627690"
      },
      "sunday": {
        "weekly": "873529386",
        "biweekly": "873562154"

      }
    }
  }
  else if(location_id == 273216 || location_id == 276649 || location_id == 277960 || location_id == 278438 || location_id == 279269){
    var data = {
      "monday": {
        "weekly": "1364033578",
        "biweekly": "1364066346"
      },
      "sunday": {
        "weekly": "1364099114",
        "biweekly": "1364131882"

      }
    }
  }
  else{
    var data = {
      "monday": {
        "weekly": "412254250",
        "biweekly": "412942378"
      },
      "sunday": {
        "weekly": "411926570",
        "biweekly": "411992106"

      }
    }
  } */

  add_cart_attribute(false)//used to for adding tags for what view something is coming from regarding flows
  var day = $("#day_selection_subscription").val()
  var weekly = $("#appstle_selling_plan_cart_new").val()
  // var val = data[day][weekly];

  document.getElementById("subscription_button").innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';
  document.getElementById("subscription_button").disabled = true;
  document.getElementById("order_type_completion").style.pointerEvents = 'none';
  document.getElementById("change_button_click_id").disabled = true;


  // await getCart(val);
  await updateItemsWithSubscriptionOptions({type: 'subscription', frequency: weekly, charge_day: day})

  var x = document.getElementById('input_delivery_date').value
  var date = parseDeliveryDateInput(x);
  var res = await update_cart_attributes()// this one adds the attributes to the cart, used in both subs and one time.
  await getCartAttributes();



  var dayweek = date.toLocaleString('default', { weekday: 'long' });
  var month = date.toLocaleString('default', { month: 'long' });
  var day = date.getDate();
  var year = date.getFullYear();
  // document.getElementById("deliveryGeoSearchField").value = document.getElementById("deliveryGeoSearchFieldnew")?.value
  // document.getElementById("deliveryGeoSearchField").dispatchEvent(new Event('change'))
  document.getElementById("order_type_completion").style = 'display:block';
  document.getElementById("change_button_click_id").disabled = false;
  document.getElementById("subscription_button").innerHTML = 'NEXT STEP';
  document.getElementById("subscription_button").disabled = false;

  document.getElementById("delivery_day").style = "display:none";
  document.getElementById("delivery_day_2").style = "display:none";
  document.getElementById("greater_toronto_sub_selection").style = "display:none";
  document.getElementById("subscription_button_div").style = "display:none !important";
  document.getElementById("delivery_day_text").style = "display:none !important";
  document.getElementById("delivery_day_completion").style = "text-transform: uppercase;";
  document.getElementById("delivery_window_text").style = "display:none";
  document.getElementById("delivery_window").style = "display:block";
  document.getElementById("delivery_window").innerHTML = `DELIVERY BETWEEN ${get_delivery_window(dayweek, location_id)}`
  document.getElementById("end_checkout_div").style = "";
  document.getElementById("delivery_day_completion").innerHTML = `DELIVERY ON ${dayweek}, ${month} ${day}, ${year}`;
  document.getElementById("dynamic-checkout-cart").style = "display:block";
  if(location_id != 270576){
    document.querySelector(".cart__dynamic-checkout-buttons").style = "display:block";
  }
  var button = document.querySelector("#end_checkout_div .cart__checkout-button")
  if (button && button.textContent && button.textContent.toLowerCase().includes("not")){
    document.getElementById("dynamic-checkout-cart").style="display:none!important"
  }
}


function get_delivery_window(dayweek, location_id) {
  console.log(dayweek);
  console.log(location_id);
  var postal_code = ''
  var day = 0
  postal_code = document.querySelector("#deliveryGeoSearchFieldnew").value
  postal_code = postal_code.toLocaleLowerCase()
  var list_postal = ['t3', 't2', 't1', 't4b', 't4a', 't4c']
  var is_calgary = false;
  for (var i = 0; i < list_postal.length; i++) {
    if (postal_code.startsWith(list_postal[i])) {
      is_calgary = true;
      break;
    }
  }
  //check for catering location or other special locations
  if(location_id == 252149 || location_id == 285777){
    var deliveryWindow = document.getElementById("deleiveryTime").value
    return `${deliveryWindow} <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>`
  }
  else{
    //first set are Calgary
    if(location_id == 137796 && dayweek == "Friday") {
      return "1PM AND 6PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 137796 && dayweek == "Sunday") {
      return "10AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 137796 && dayweek == "Monday") {
      return "11AM AND 6PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Toronto
    else if(location_id == 242677 && dayweek == "Sunday") {
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 242677 && dayweek == "Monday") {
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Ottawa
    else if(location_id == 285794 && dayweek == "Sunday") {
      return "9AM AND 2PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 285794 && dayweek == "Monday") {
      return "9AM AND 2PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //London ON
    else if(location_id == 289774  && dayweek == "Sunday") {
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 289774  && dayweek == "Monday") {
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Vancouver
    else if(location_id == 137798 || location_id == 270994) {
      return "10AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //LA
    else if(location_id == 278438 && dayweek == "Monday" ){
      return "7AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    else if(location_id == 278438 && dayweek == "Sunday"){
      return "7AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //USA-West
    //Vegas
    else if(location_id == 273216){
      return "10AM AND 3PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //San Francisco
    else if(location_id == 279269){
      return "10AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Denver
    else if(location_id == 299051){
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Salt Lake City
    else if(location_id == 276649){
      return "10AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //Phoenix
    else if(location_id == 277960){
      return "9AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //San Deago
    else if(location_id == 288292) {
      return "7AM AND 5PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //USA East
    //NY
    else if(location_id == 301948) {
      return "8AM AND 8PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
    }
    //fall through for all others
    return "10AM AND 4PM <span class='info_icon hover_mouse' onclick='show_info()'>&#9432;<span>"
  }
}

function close_modal_info() {
  document.getElementById("info_modal").style = "display:none"
}

function show_info() {
  document.getElementById("info_modal").style = "display:block"
}

function close_modal_info_new() {
  document.getElementById("info_modal_new").style = "display:none"
}

function show_info_new() {
  document.getElementById("info_modal_new").style = "display:block"
}

function set_selector() {
  // var x = document.getElementById("deliveryDatePicker")

  // var selector = x.querySelectorAll(".picker");
  // if (selector) {
  //   try {

  //     selector[0].classList.add("picker--focused")
  //     selector[0].classList.add("picker--opened")
  //     selector[0].style = "margin-top:20px"
  //   }
  //   catch (error) {
  //     selector[0].classList.add("picker--focused")
  //     selector[0].classList.add("picker--opened")
  //     selector[0].style = "margin-top:20px"


  //   }



  // }
}

async function delivery_day_button() {
  document.getElementById("dynamic-checkout-cart").style=""
  document.getElementById("delivery_day_button_inner").disabled = true;
  document.getElementById("delivery_day_button_inner").innerHTML = '<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>';

  var deliveryWindow = document.getElementById("deleiveryTime").value
  console.log(deliveryWindow);

  var raw = (document.getElementById("input_delivery_date").value || "").trim();
  var date = parseDeliveryDateInput(raw);

  if (!(date instanceof Date) || isNaN(date.getTime())) {
    document.getElementById("delivery_day_button_error").innerHTML =
      "Please select a valid delivery date.";
    document.getElementById("delivery_day_button_inner").innerHTML = "CONFIRM DELIVERY DAY";
    return;
  }


  var dayweek = date.toLocaleString('default', { weekday: 'long' });
  var month = date.toLocaleString('default', { month: 'long' });
  var day = date.getDate();
  var year = date.getFullYear();
  var res = await update_cart_attributes();
  document.getElementById("delivery_day_button_error").innerHTML = "";
  document.getElementById("delivery_day").style = "display:none";
  document.getElementById("delivery_day_button").style = "display:none !important";
  document.getElementById("delivery_day_text").style = "display:none !important";
  document.getElementById("delivery_day_completion").style = "text-transform: uppercase;"
  document.getElementById("delivery_day_completion").innerHTML = `DELIVERY ON ${dayweek}, ${month} ${day}, ${year}`
  document.getElementById("delivery_window").style = "display:block"
  document.getElementById("delivery_window_text").style = "display:none"
   document.getElementById("timeSelectContainer").style = "display:none"
  console.log("in delivery_day_button");
  var location_id = res.attributes["Delivery-Location-Id"];
    document.getElementById("delivery_window").innerHTML = `DELIVERY BETWEEN ${get_delivery_window(dayweek, location_id)}`
    //document.getElementById("delivery_window").innerHTML = `DELIVERY BETWEEN ${get_delivery_window()}`
    document.getElementById("end_checkout_div").style = "";
    document.getElementById("delivery_day_button_inner").disabled = false;
    document.getElementById("delivery_day_button_inner").innerHTML = 'NEXT STEP';
    var button = document.querySelector("#end_checkout_div .cart__checkout-button")
    if (button && button.textContent && button.textContent.toLowerCase().includes("not")){
      document.getElementById("dynamic-checkout-cart").style="display:none!important";
    }
   await update_checkout_button(res)


  /*document.getElementById("delivery_window").innerHTML = `DELIVERY BETWEEN ${get_delivery_window()}`
  document.getElementById("end_checkout_div").style = "";
  document.getElementById("delivery_day_button_inner").disabled = false;
  document.getElementById("delivery_day_button_inner").innerHTML = 'NEXT STEP';
  var button = document.querySelector("#end_checkout_div .cart__checkout-button")
  if (button && button.textContent && button.textContent.toLowerCase().includes("not")){
    document.getElementById("dynamic-checkout-cart").style="display:none!important";
  }
 await update_checkout_button(res)*/
}

async function addBundleProps() {
  // Pass what type of bundle we're assigning to props function
  let bundleKey = 'default'
  if (['242677', '270213', '285794', '289774', '319959'].includes(`${location_id}`)) {
    bundleKey = 'toronto'
  } else if (['273216', '276649', '277960', '278438', '279269', '288292', '299051', '301750'].includes(`${location_id}`)) {
    //273216 <- vegas
    //276649 <- salt lake city
    //277960 <- phoenix
    //278438 <- los angeles
    //279269 <- san francisco
    //288292 <- San Deago
    //301750 <- santa clair
    bundleKey = 'usa-west'
  }
  else if (['301948', '310459', '310466'].includes(`${location_id}`)){
    bundleKey = 'usa-east'
  }

  await window.bear.addBundlePropsToItems(bundleKey)
}

async function submit_form_checkout(event) {
  // reload cart page if bundle is not assigned
  const res = await fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
  const data = await res.json()
  const item = data.items[0]
  if (!item?.properties?._rc_bundle) {
    window.location.reload()
    return
  }

  try {
    document.getElementById("end_checkout_div").querySelector("button").innerHTML = `<i class="fa fa-spinner fa-spin" style="font-size:20px"></i>`
  }
  catch (error) {
    console.log(error)
  }

  const queryString = window.location.search;
  let params = new URLSearchParams(queryString);
  var view = params.get('view')

  var discount_code = getCookie("discount_code")
  // Locale follows the active Weglot language — see assets/checkout-locale.js
  var checkout_locale = window.igoCheckoutLocale ? window.igoCheckoutLocale() : 'en-AU'
  if(discount_code != null && view == "timer"){
    location.href = `/checkout?discount=${discount_code}&locale=${checkout_locale}&method=delivery&skip_shopify_pay=true&step=contact_information&view=show-timer`
  }
  else if(discount_code != null){
    location.href = `/checkout?discount=${discount_code}&locale=${checkout_locale}&method=delivery&skip_shopify_pay=true&step=contact_information`
  }
  // document.querySelector('#checkout').click();

}

function delivery_time_button(){
  document.getElementById("end_checkout_div").style = "";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (e) {
    decodedCookie = document.cookie;
  }
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function order_type_completion_back() {
  document.getElementById("order_type_heading").style = "display:block";
  document.getElementById("delivery_day_text").style = "display:block";
  document.getElementById("order_type").style = "display:block";
  document.getElementById("order_type_completion").style = "display:none";
  document.getElementById("order_type_completion").innerHTML = "";
  document.getElementById("delivery_day_button_error").innerHTML = "";
  document.getElementById("delivery_day_button").style = "display:none !important";
  document.getElementById("delivery_day").style = "display:none !important";
  document.getElementById("delivery_day_2").style = "display:none !important";
  document.getElementById("greater_toronto_sub_selection").style = "display:none !important";
  document.getElementById("order_type_completion").style = "display:none !important";
  document.getElementById("delivery_window").style = "display:none !important";
  document.getElementById("delivery_day_completion").style = "display:none !important";
  document.getElementById("end_checkout_div").style = "display:none !important";
  document.getElementById("delivery_window_text").style = "display:block";

}

function delivery_day_completion_back() {
  document.getElementById("delivery_day_text").style = "display:block";
  var y = document.getElementById("order_type_completion");
  if (y && y.textContent.includes("SUBSCRIPTION")) {
    // day_selection_subscription(true)
    document.getElementById("delivery_day").style = "display:none";
    document.getElementById("subscription_button_div").style = "display:block";
    document.getElementById("delivery_day_2").style = "display:block";
    document.getElementById("greater_toronto_sub_selection").style = "display:block";


    //       if(window.screen.width<768)
    //  	document.getElementById('delivery_day_2').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});

  } else {
    document.getElementById("delivery_day").style = "display:block";
    //       if(window.screen.width<768)
    //        document.getElementById('delivery_day').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    document.getElementById("delivery_day_button").style = "display:block";
    document.getElementById("delivery_day_2").style = "display:none";
    document.getElementById("greater_toronto_sub_selection").style = "display:none";
  }

  document.getElementById("delivery_window").style = "display:none";
  document.getElementById("delivery_day_completion").style = "display:none";
  document.getElementById("end_checkout_div").style = "display:none !important";
  document.getElementById("delivery_window_text").style = "display:black"


}

//function to update the attributes for the cart
async function update_cart_attributes(){
  const raw = (document.getElementById("input_delivery_date").value || "").trim();

  // ✅ Accept yyyy-mm-dd (preferred) and parse safely as LOCAL date (no timezone shift)
  let d_d = null;
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [y, m, d] = raw.split('-').map(Number);
    d_d = new Date(y, m - 1, d);
  } else {
    // fallback (older behavior)
    d_d = new Date(raw);
  }

  // ✅ If invalid, do NOT write attributes like NaN/aN/aN
  if (!(d_d instanceof Date) || isNaN(d_d.getTime())) {
    console.error("Invalid delivery date value:", raw);
    return await fetch('/cart.js').then(r => r.json());
  }

  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var dayName = days[d_d.getDay()];
  var d_d_str = `${d_d.getFullYear()}/${("0" + (d_d.getMonth() + 1)).slice(-2)}/${("0" + d_d.getDate()).slice(-2)}`;

  var deliveryWindow = document.getElementById("deleiveryTime").value
  var postalInput = "";
  if(location_id == 270576){
    var postalInput = document.getElementById("deliveryGeoSearchFieldnew").value;
  }

  var cartView = "";
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var view = urlParams.get('view')
  if(view == "offer"){
    cartView = "offer";
  }
  


  var x = {
    "Pickup-Location-Id": "",
    "Pickup-Day": "",
    "Pickup-Date": "",
    "Pickup-Time": "",
    "Delivery-Location-Id": location_id,
    "Delivery-Day": dayName,
    "Delivery-Date": d_d_str,
    "Delivery Type": document.getElementById("delivery_type_input").checked? "Office":"Home",
    "Delivery-Time": deliveryWindow,
    "Shipping-Day": "",
    "Shipping-Date": "",
    "Shipping-Time": "",
    "Custom_attribute_2": "",
    "Pickup-Location-Company": "",
    "Pickup-Location-Address-Line-1": "",
    "Pickup-Location-Address-Line-2": "",
    "Pickup-Location-City": "",
    "Pickup-Location-Region": "",
    "Pickup-Location-Postal-Code": "",
    "Pickup-Location-Country": "",
    "Delivery-Slot-Id": "",
    "Checkout-Method": "delivery",
    "Postal-Input": postalInput,
    "cart-view": cartView

}


var res = await fetch('/cart/update.js',{
        method: 'POST',
        headers:{"Content-Type": "application/json"},
        body: JSON.stringify({"attributes":x})
      })
res = await res.json()

var itemProperties = res.items[0].properties || {}
var props = {
  ...itemProperties,
  "_Delivery-Location-Id": location_id,
  "_Delivery-Day": dayName,
  "_Delivery-Date": d_d_str,
  "_Delivery Type": document.getElementById("delivery_type_input").checked? "Office":"Home",
  "_Checkout-Method": "delivery"
}

var line_attributes = {
  quantity:res.items[0].quantity,
  properties:props,
  id:res.items[0].key
}
res = await fetch('/cart/change.js',{
  method: 'POST',
  headers:{"Content-Type": "application/json"},
  body: JSON.stringify(line_attributes)
})
res = await res.json()

return res;
}

function update_progress_bar_2(data) {

  var discount_code = getCookie("discount_code");
  
  var free_delivery = 6500;
  var minimum_order = 4000;
  var has_selling_plan_allocation = false;
  var items = ((data||{}).items || [])
  var original_price = 0;

  var price_without_discounts = data.original_total_price
  
  items.forEach(item=>{
    if(Object.keys(item.selling_plan_allocation|| {}).length>0){
      has_selling_plan_allocation=true;
    }
    if(!gift_cards.includes(item.id)){
      if (item.original_line_price != item.final_line_price){
        original_price+=item.final_line_price
      }
      else{
      original_price+= item.original_line_price;
      }
    }
    else{
      found_gift_card = true;
    }
  })

  if (has_selling_plan_allocation) {
    free_delivery = 6500;
    minimum_order = 3800;
  }
  const progress = document.getElementById("progress_bar_free_shipping");
  const progress_title = document.getElementById("progress_title");
  const price = document.querySelector(".totals__subtotal-value");

  let diff = free_delivery - price_without_discounts;
  let order_difference = (minimum_order - price_without_discounts);
  if (order_difference <= 0) {
    if (diff >= 0) {
      diff = (diff / 100).toFixed(2)
      progress_title.innerHTML = `You are $${diff} Away from Free Delivery ($6.95 fee).`
    } else {
      progress_title.innerHTML = `Hooray! You unlocked free delivery 🎉`

    }
  }
  else {
    minimum_order = (minimum_order / 100).toFixed(2)
    progress_title.innerHTML = `Your order is below the $${minimum_order} minimum order before discount.`
  }
  let percentage = ((original_price) / free_delivery) * 100;

  if (percentage >= 0) {

    progress.style = `width:${percentage}%`
  }
  var p = (data.total_price) / 100;
  price.innerHTML = `$${p}`;

}

var items = [];
fetch('/cart.js', {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json'
  },
})
  .then(res => res.json())
  .then(async (data) => {

    if (((data || {}).items || []).length > 0) {

      items = data.items;
      var selling_plan_allocation = false;
      var selling_plan_id = '';
      var non_item_selling_plan = [];
      var original_price = 0
      items.forEach(item => {
        if (item.selling_plan_allocation) {
          selling_plan_allocation = true;
          selling_plan_id = item.selling_plan_allocation.selling_plan.id
        } else {
          non_item_selling_plan.push(item)
        }
      })
      update_progress_bar_2(data)

      if (selling_plan_allocation && non_item_selling_plan.length > 0) {
        // getCart(selling_plan_id)
        await updateItemsWithSubscriptionOptions({type: 'onetime'})
      }
      if (selling_plan_id) {
        $("#appstle_selling_plan_cart").val(selling_plan_id);
      }
      var total = (original_price - (original_price * 5) / 100) / 100;
      if (selling_plan_allocation) {
        total = ((original_price) / 100)
      } else {
      }
      update_selection()
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });

/* $('#appstle_selling_plan_cart').on('change', function () {

  getCart($("#appstle_selling_plan_cart").val())

}); */
//click for the radio button
$('#cart_onetime_radio').on('click', function () {
  //location check for catering
  if(location_id == 252149 || location_id == 270576 || location_id == 285777){
    document.getElementById('cart_onetime_radio_section').style = 'background-color:#eee';
    //document.getElementById('cart_subscribe_radio_section').style = '';
    //document.getElementById("appstle_text_red").innerHTML = "YOU COULD BE SAVING 5% ON THIS ORDER";
    document.getElementById('cart_subscribe_radio_section').classList.remove('appstle_cart_radio_selected')
  }
  else{
    document.getElementById('cart_onetime_radio_section').style = 'background-color:#eee';
    //document.getElementById('cart_subscribe_radio_section').style = '';
    document.getElementById("appstle_text_red").innerHTML = "YOU COULD BE SAVING 5% ON THIS ORDER";
    document.getElementById('cart_subscribe_radio_section').classList.remove('appstle_cart_radio_selected')
  }

});

//click for the entire span not just the button
$('#one_time_purchase').on('click', function () {
  //catering location check to not display popup
  if(location_id == 252149 || location_id == 270576 || location_id == 285777){
    //document.getElementById('cart_onetime_radio_section').style = 'background-color:#eee';
    document.getElementById('cart_subscribe_radio').style = 'background-color:#eee';
    document.getElementById('cart_onetime_radio').style = 'background-color:#000';
    //document.getElementById('cart_subscribe_radio_section').style = '';
    //document.getElementById("appstle_text_red").innerHTML = "YOU COULD BE SAVING 5% ON THIS ORDER";
    document.getElementById('cart_subscribe_radio_section').classList.remove('appstle_cart_radio_selected')
    document.getElementById('cart_subscribe_radio').checked = false;
    console.log("clicked");
  }
  else{
    //document.getElementById('cart_onetime_radio_section').style = 'background-color:#eee';
    document.getElementById('cart_subscribe_radio').style = 'background-color:#eee';
    document.getElementById('cart_onetime_radio').style = 'background-color:#000';
    document.getElementById('cart_subscribe_radio_section').style = '';
    document.getElementById("appstle_text_red").innerHTML = "YOU COULD BE SAVING 5% ON THIS ORDER";
    document.getElementById('cart_subscribe_radio_section').classList.remove('appstle_cart_radio_selected')
    document.getElementById('cart_subscribe_radio').checked = false;
    console.log("clicked");
  }


});

$('#cart_subscribe_radio').on('click', function () {
  document.getElementById('cart_subscribe_radio_section').style = 'background-color:#eee'
  document.getElementById('cart_subscribe_radio').style = 'background-color:#000'
  document.getElementById('cart_onetime_radio_section').style = '';
  document.getElementById('cart_onetime_radio').style = 'background-color:#eee';
  document.getElementById("appstle_text_red").innerHTML = "";

});
//click for entire span for sub purchase
$('#subscribition_purchase').on('click', function () {
  document.getElementById('cart_subscribe_radio_section').style = 'background-color:#eee'
  document.getElementById('cart_subscribe_radio').style = 'background-color:#000'
  document.getElementById('cart_onetime_radio_section').style = '';
  document.getElementById('cart_onetime_radio').style = 'background-color:#eee';
  document.getElementById("appstle_text_red").innerHTML = "";
  document.getElementById('cart_onetime_radio').checked = false;
  document.getElementById('cart_subscribe_radio').checked = true;
  console.log("clicked subs");
});



async function getCart(value) {
  addLoader();
  try {
    var res = await fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })

    var data = await res.json()
    if ((data.items || []).length > 0) {
      items = data.items;
      await clearCart(items, value);
    }
  }
  catch (error) {

  }

  //     .then(res => res.json())
  //         .then(data => {
  //             if ((data.items || []).length > 0) {
  //                 items = data.items;
  //                 clearCart(items, value);
  //             }
  //         })
  //         .catch((error) => {
  //                 removeLoader();
  //             console.error('Error:', error);
  //         });
}

async function clearCart(items, sellingPlan) {
  try {
    var res = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    var data = res.json()
    await udpateItem(items, sellingPlan)
  }
  catch (error) {

  }

  //       .then(res => res.json()).then(data=>{
  //       udpateItem(items,sellingPlan)

  //       })
  // .catch((error) => {
  //   removeLoader();

  // });
}

function addLoader() {
  // $('body').append(`<div id="appstle_overlay"><div class="appstle_loader"></div><div class="appstle_loader_text">Updating your cart...</div></div>`);

}
function removeLoader() {
  //     $("#appstle_overlay").remove()


}

async function udpateItem(items, sellingPlan) {

  var i = []
  if (sellingPlan) {
    items.forEach((item) => {
      if (item.gift_card) {
        i.push(
          {
            "id": item.id,
            "quantity": item.quantity
          }
        )
      }
      else {
        i.push(
          {
            "id": item.id,
            "quantity": item.quantity,
            "selling_plan": sellingPlan
          }
        );
      }
    });
  } else {
    items.forEach((item) => {
      i.push(
        {
          "id": item.id,
          "quantity": item.quantity
        }
      );
    });
  }
  let formData = {
    "items": i,
    sections: getSectionsToRender().map((section) => section.section)
  };
  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    var data = await res.json()

    removeTable(data.items, data.sections)
  }
  catch (error) {


  }

  // .then(res => res.json())
  // .then(data=>removeTable(data.items,data.sections)
  //        )
  // .catch((error) => {
  //              removeLoader();

  //   console.error('Error:', error);
  // });
}

/*
function getLineItemAttributes() {
  var d_d =new Date(document.getElementById("input_delivery_date").value);
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var dayName = days[d_d.getDay()];
  d_d = `${d_d.getFullYear()}/${("0" + (d_d.getMonth() + 1)).slice(-2)}/${("0" + (d_d.getDate())).slice(-2)}`

  return {
    "_Delivery-Location-Id": location_id,
    "_Delivery-Day": dayName,
    "_Delivery-Date": d_d,
    "_Delivery Type": document.getElementById("delivery_type_input").checked? "Office":"Home",
    "_Checkout-Method": "delivery"
  }
}
*/

function getLineItemAttributes() {
  const raw = (document.getElementById("input_delivery_date").value || "").trim();
  let d_d = parseDeliveryDateInput(raw);

  if (!(d_d instanceof Date) || isNaN(d_d.getTime())) {
    console.error("Invalid delivery date value:", raw);
    // safe fallback: return empty so we don’t poison properties
      return {
    "_Delivery-Location-Id": location_id,
    "_Delivery-Day": dayName,
    "_Delivery-Date": d_d_str,
    "_Delivery Type": document.getElementById("delivery_type_input").checked? "Office":"Home",
    "_Checkout-Method": "delivery"
    }
  }

  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var dayName = days[d_d.getDay()];
  var d_d_str = `${d_d.getFullYear()}/${("0" + (d_d.getMonth() + 1)).slice(-2)}/${("0" + d_d.getDate()).slice(-2)}`;
}


async function updateItemsWithSubscriptionOptions(options) {
  // return if onetime selected and no items have selling plans
  if (options.type === 'onetime') {
    // get cart
    const res = await fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
    const data = await res.json()
    // check if any item has a selling plan
    const items = data.items
    const anyItemHasSellingPlan = items.some((item) => !!item.selling_plan_allocation?.selling_plan)
    if (!anyItemHasSellingPlan) {
      return
    }
  }

  const items = await window.bear.getItemsWithSellingPlans(options)
  const itemProperties = items[0].properties || {}
  items[0].properties = {
    ...itemProperties,
    ...getLineItemAttributes()
  }

  try {
    const clearRes = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
    })
    await clearRes.json()

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: items,
        sections: getSectionsToRender().map((section) => section.section)
      })
    })
    const data = await addRes.json()

    removeTable(data.items, data.sections)
  } catch (error) {
    console.error('Error:', error)
  }
}

function removeTable(items, sections) {
  getSectionsToRender().forEach((section => {
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    if(location_id != 270576){;
      elementToReplace.innerHTML = getSectionInnerHTML(sections[section.section], section.selector);
    }

  }));
  removeLoader();
}

function getSectionsToRender() {
  return [
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '#cart_new_items',
    },
    {
      id: 'main-cart-items',
      section: document.getElementById('main-cart-items').dataset.id,
      selector: '#new_progress',
    },
    //       {
    //         id: 'cart-live-region-text',
    //         section: 'cart-live-region-text',
    //         selector: '.shopify-section'
    //       },
    //       {
    //         id: 'main-cart-footer',
    //         section: document.getElementById('main-cart-footer').dataset.id,
    //         selector: '.totals__subtotal-value',
    //       }
  ];
}

function getSectionInnerHTML(html, selector) {
  console.log("in second progress bar");
  var x = new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;

  if (selector == "#new_progress") {

    var y = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(".totals__subtotal-value").innerHTML
    var price = parseFloat(y.replace("$", ""))
    x = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
    price = price * 100
    const progress = x.querySelector("#progress_bar_free_shipping");
    const progress_title = x.querySelector("#progress_title");
    var free_delivery = 6500;
    var minimum_order =4000;
    if ($('#cart_subscribe_radio').is(':checked')) {
      free_delivery = 6500;
      minimum_order = 3800;
    }
    let diff = free_delivery - (price);
    let order_difference =  minimum_order - price;
    if (order_difference <= 0) {
      if (diff >= 0) {
        diff = (diff / 100).toFixed(2);
        progress_title.innerHTML = `You are $` + diff + ` Away from Free Delivery ($6.95 fee).`
      } else {
        progress_title.innerHTML = `Hooray! You unlocked free delivery 🎉 `;

      }
    }
  else{
    minimum_order = (minimum_order / 100).toFixed(2)

    progress_title.innerHTML = `Your order is below the $${minimum_order} minimum order.`
  }
    let percentage = ((price) / free_delivery) * 100;;

    if (percentage >= 0) {

      progress.style = `width:` + percentage + `%`;
    }

    x = x.innerHTML;
  }

  return x

}




const productRecommendationsSection = document.querySelector('.product-recommendations');
// 4431338176554
const productId = 6682736295978
fetch(window.Shopify.routes.root + `recommendations/products?product_id=${productId}&limit=10&section_id=product-recommend`)
  .then(response => response.text())
  .then((text) => {
    const html = document.createElement('div');
    html.innerHTML = text;
    const recommendations = html.querySelector('.product-recommendations');

    if (recommendations && recommendations.innerHTML.trim().length && productRecommendationsSection) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
      $("#product-recommendation-owl").owlCarousel({
        loop: true,
        lazyLoad: true,
        //         autoHeight:true,
        //          autoplay:true,
        //     autoplayTimeout:1000,
        //     autoplayHoverPause:true,
        margin: 30,
        responsiveClass: true,
        dots: false,
        nav: true,
        stagePadding: 0,
        responsive: {
          0: {
            items: 2,
          },
          600: {
            items: 3,
          },
          1000: {
            items: 4,

          }
        },
        navText: ['<i class="fa fa-angle-left" aria-hidden="true"></i>', '<i class="fa fa-angle-right" aria-hidden="true"></i>']
      });

      updateQuantity()
      const row = document.querySelectorAll("#product-recommendation-owl .card-wrapper");
      var productTitles = []
      row.forEach(card => { productTitles.push(card.querySelector(".card-information__text.h2")) });



      const productTitleHeights = productTitles.map(wrapper => wrapper.offsetHeight);
      const maxProductTitleHeight = Math.max(...productTitleHeights);
      productTitles.forEach(wrapper => wrapper.style.height = maxProductTitleHeight + "px");

      //set equal price wrapper height
      var priceWrappers = []
      row.forEach(card => { priceWrappers.push(card.querySelector(".price-vendor-wrapper")) });
      const priceWrapperHeights = priceWrappers.map(wrapper => wrapper.offsetHeight);
      const maxPriceWrapperHeight = Math.max(...priceWrapperHeights);
      priceWrappers.forEach(wrapper => wrapper.style.height = maxPriceWrapperHeight + "px");

    }
  });



function updateQuantity() {
  fetch("/cart.js", {
    credentials: 'same-origin',
    cache: 'no-store'
  })
    .then((response) => response.json())
    .then((cart) => {
      var single = getSingleBundleS()
      cart.items.forEach((item) => {
        const itemQuantityInput = document.querySelectorAll(
          `#product-recommendation-owl quantity-input-new[data-id='${item.variant_id}']`
        ) || [];
        var addons = getAddOnSN();
        var variant_ids = addons.variant_ids;
        if (addons.key == cart.token && variant_ids && (variant_ids.includes(item.id) || variant_ids.includes((item.id).toString()))) {
          const addon = document.querySelector(
            `#product-recommendation-owl addon-overlay input[data-id='${item.id}']`);
          if (addon) {
            addon.checked = true;
          }
        }
        if (single[item.id]) {
          for (var key in single[item.id]) {
            if (single[item.id][key] * 1 > 0) {


              const a = document.querySelector(
                `#product-recommendation-owl addon-overlay input[data-id='${key}']`);

              if (a && a.dataset.single_bundle == "true") {
                a.checked = true;
                const x = document.querySelector(
                  `#product-recommendation-owl quantity-input[data-id='${key}']`
                );
                if (x) {
                  x.input.value = single[item.id][key];
                  x.handleMinusButton();
                }
              }
            }
          }
        }
        if (!itemQuantityInput) return;
        itemQuantityInput.forEach(itemInput=>{
          itemInput.input.value = item.quantity;
          itemInput.handleMinusButton();
        })
        // itemQuantityInput.input.value = item.quantity;
        // itemQuantityInput.handleMinusButton();
      });


    });
}

function getAddOnSN() {
  try {
    if (localStorage.getItem('addons')) {
      return JSON.parse(localStorage.getItem('addons'))
    }
  }
  catch (error) {

  }
  return { 'key': '', "variant_ids": [] }
}

function getSingleBundleS() {
  try {
    if (localStorage.getItem('single_bundle')) {
      return JSON.parse(localStorage.getItem('single_bundle'))
    }
  }
  catch (error) {

  }
  return {}

}

//function used to double check if  cart has the delivery attribute attached,
//if not it adds the attributes again and checks again for them through regression
function getCartAttributes(){

  const cartAtts = []

  fetch('/cart.js', {
    method: 'GET',

  }).then(res => res.json()).then(res => {
    for (var x in res.attributes) {
      cartAtts.push(x);
    }

    if(cartAtts.includes("Delivery-Date") != true){
      //console.log("Delivery-date NOT included");
      update_cart_attributes();
      getCartAttributes();
    }
    else{
      //console.log("Delivery-date included");
    }
  });
}


//helper function for displaying the correct sub dates based off location
function buildDeliveryDaySelectFromZapietLocation(zapietLocation) {
  const select = document.getElementById("day_selection_subscription");
  if (!select || !zapietLocation?.delivery) return;

  const delivery = zapietLocation.delivery;

  const orderedDays = ["sunday","monday"];

  const enabledDays = orderedDays.filter((day) => {
    const dayObj = delivery[day];
    // Use slots.enabled if present; fallback to "slots array has entries"
    const slotsEnabled = !!dayObj?.slots?.enabled;
    const hasSlots = Array.isArray(dayObj?.slots?.slots) && dayObj.slots.slots.length > 0;
    return slotsEnabled || hasSlots;
  });

  // Rebuild options
  select.innerHTML = "";
  enabledDays.forEach((day) => {
    const opt = document.createElement("option");
    opt.value = day;
    opt.textContent = day.charAt(0).toUpperCase() + day.slice(1);
    select.appendChild(opt);
  });

}

